import {useState,useEffect} from 'react'
export default function useNow(){
    const [now,setNow]=useState(new Date());
    useEffect(()=>{
        const id=setInterval(()=>setNow(new Date()),1000);
        return ()=>clearInterval(id);
    },[]);
    return now;
}
